<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-20 16:03:03
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-20 17:10:02
 * @FilePath: \partner.chaoyongtuan.com\src\views\secondColonelManage\colonelActivitySquare\detail\components\ksTableCell\channelShopCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="channelShopCell">
		<div class="flex flex-align-center">
			<img class="shop_img" :src="row.itemImgUrl" alt="" />
			<div class="box ml-10 PingFang yx-color-text-primary fz-13">
				<div class="flex">
					<p class="title ellipsis">{{ row.itemTitle }}</p>
					<el-tooltip class="item" effect="dark" placement="top">
						<div slot="content" class="content">
							<span>商品ID</span><span class="ml-10">{{ row.itemId }}</span>
							<img src="@/assets/public/copy-icon.png" alt="" @click="copy(row.itemId)" />
						</div>
						<span class="ID-sign yx-color-primary nowrap">ID</span>
					</el-tooltip>
				</div>
				<div v-if="row.tabName === '0'">
					<span>类目：</span>
					<span>{{ row.itemCategoryName }}</span>
				</div>
				<div class="flex flex-align-center" v-if="row.tabName === '1'">
					<span class="ml-10">库存：</span><span>{{ row.itemStock | formatEmpty }}</span> <span>售价：</span
					><span>¥{{ row.itemPrice | formatEmpty }}</span> <span class="ml-10">销量：</span><span>{{ row.itemVolume | formatEmpty }}</span>
				</div>
				<div class="flex flex-align-center" v-if="row.tabName === '1'">
					<span class="ml-10">佣金率：</span><span>{{ row.itemCommissionRate | formatEmpty }}%</span> <span class="ml-10">服务费率：</span
					><span>{{ row.investmentPromotionRate | formatEmpty }}%</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	data() {
		return {};
	},
	mixins: [mixin],
	methods: {
		copy(value) {
			var inputTest = document.createElement('textarea');
			inputTest.value = value;
			document.body.appendChild(inputTest);
			inputTest.select();
			document.execCommand('Copy');
			inputTest.className = 'oInput';
			inputTest.style.display = 'none';
			this.$message.success('复制成功');
			document.body.removeChild(inputTest);
		},
	},
};
</script>
<style lang="less" scoped>
.title {
	max-width: 300px;
}
.ellipsis {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.category {
	width: 150px;
}
.shop_img {
	width: 40px;
	height: 40px;
	border-radius: 5px;
}
.ID-sign {
	padding: 0px 4px;
	border-radius: 2px;
	margin-left: 3px;
	background-color: @color-parachrome;
	cursor: default;
}
.content {
	display: flex;
	align-items: center;
	img {
		margin-left: 8px;
		width: 16px;
		height: 16px;
		cursor: pointer;
	}
}
</style>